import React, { Fragment, useState, useEffect, useMemo } from "react";
import "./styles.css";

import { ReactComponent as TickIcon } from "common/assets/svg/tickIconOffer.svg";
import { ReactComponent as Cancel } from "common/assets/svg/cancel.svg";
import { ReactComponent as BackIcon } from "common/assets/svg/leftArrow.svg";
import {
  clearLocationAfterAuth,
  clearResetPassword,
  signIn,
  deletesignInData,
} from "common/features/auth/AuthActions";
import { useSpring, useTransition, animated } from "react-spring";
import { useHistory, useParams, useLocation } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "common/rootReducer";
import { setCartAuthPending } from "common/features/cart/cartActions";
import { GUEST_CART } from "common/constants";
import ForgotInnerPopup from "../forgotInnerPopup";
import PopupSign from "./PopupSign";

function LoginPromt(props: any) {
  const dispatch = useDispatch();
  const location = useLocation<any>();

  const { isOpen, visible, openGuestPopup,openSignUpPopoup } = props;
  const history = useHistory();
  const authState = useSelector((state: RootState) => state.auth);
  const cart = useSelector((state: RootState) => state.cart);
  const toLocationAfterAuth = useSelector(
    (state: RootState) => state.auth.toLocationAfterAuth
  );
  const [loginRequestPopup, setloginRequestPopup] = useState(false);
  const guestCart = localStorage.getItem(GUEST_CART);
  const hideLogo = useMemo(() => {
    return !toLocationAfterAuth.includes("table") && guestCart;
  }, [guestCart, toLocationAfterAuth]);

  const [user, setUser] = useState({ email: "", password: "" });
  const [signUp, setSignUp] = useState(false);
  // useEffect(() => {
  //   if (!authState.signInLoading && authState.signedIn) {
  //     // history.push("/");
  //     console.log("Login Success :::::");

  //     localStorage.removeItem(GUEST_CART);
  //   }
  //   dispatch(clearResetPassword());
  //   dispatch(deletesignInData());
  // }, []);

  const handleClick = () => {
    // setOpen(!open)
    setloginRequestPopup(true);
  };
  const opacityProps = useSpring({
    from: { opacity: 0 },
    to: { opacity: isOpen ? 1 : 0 },
  });

  const transitions = useTransition(isOpen, null, {
    from: { transform: "translate3d(0,-15px,0)" },
    enter: { transform: "translate3d(0,0px,0)" },
    leave: { transform: "translate3d(0,-15px,0)" },
    unique: true,
  });

  return (
    <Fragment>
      {isOpen ? (
        <Fragment>
          <div id="modal-background" style={{ zIndex: '20' }}></div>
          <animated.div className="CPWrapper" style={opacityProps}>
            {transitions.map(({ item, key, props }) =>
              item ? (
                <animated.div
                  className="CPContainer"
                  key={key}
                  //  style={props}
                  style={{
                    backgroundColor: "#EDEDED",
                    width: 400,
                    minHeight: 400,
                  }}
                >
                  <div className="loginDesigns">
                    <span id="return-back-popup">
                      <BackIcon
                        onClick={() => {
                          visible(true);
                        }}
                        className="darkBackIcon"
                      />
                    </span>
                    <span className="loginHead">Login</span>
                    <Cancel
                      className="canclbtn"
                      onClick={() => visible(true)}
                    />
                  </div>
                  <div>
                    <PopupSign
                      onClose={visible}
                      openGuestPopup={openGuestPopup}
                      openSignUpPopoup={openSignUpPopoup}
                    />
                  </div>
                </animated.div>
              ) : null
            )}
          </animated.div>
        </Fragment>
      ) : null}
    </Fragment>
  );
}

export default LoginPromt;
